import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const IMPORT_LINES_MUTATION = gql`
mutation importLines(
  $documentVersion: DocumentVersionInput!,
  $sources: [ImportLinesInput!]!
) {
  quotes {
    modify(documentVersion: $documentVersion) {
      importLines(sources: $sources) {
        newLines {
          id
        }
      }
    }
  }
}
`;

@Injectable({
  providedIn: 'root'
})
export class ImportLinesMutation extends Mutation<RootMutation> {
  document = IMPORT_LINES_MUTATION;
}
